import { Grid, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useQuoteContext } from '../QuoteContextProvider';
import { commonInputProps } from '../QuoteDetailsForm/QuoteDetailsForm.common';
import { TsrctQuoteMode } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { useFormFieldErrorTranslation } from '~/hooks';

enum DetailsFormField {
  SUPPLIER_REFERENCE = 'supplierReference',
}

const editModeMap: { [key in TsrctQuoteMode]: { [key in DetailsFormField]?: boolean } } = {
  [TsrctQuoteMode.NOOP]: {
    [DetailsFormField.SUPPLIER_REFERENCE]: false,
  },
  [TsrctQuoteMode.UPLOAD]: {
    [DetailsFormField.SUPPLIER_REFERENCE]: true,
  },
  [TsrctQuoteMode.EDIT]: {
    [DetailsFormField.SUPPLIER_REFERENCE]: true,
  },
  [TsrctQuoteMode.BID_SHEET]: {
    [DetailsFormField.SUPPLIER_REFERENCE]: true,
  },
  [TsrctQuoteMode.BID_SHEET_PROPOSAL]: {
    [DetailsFormField.SUPPLIER_REFERENCE]: true,
  },
};

export const DetailsForm = () => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationQuoteDetailsWidget' });
  const { errorToHelperText } = useFormFieldErrorTranslation();
  const { quoteMode } = useQuoteContext();
  const edit = editModeMap[quoteMode];
  return (
    <>
      <Grid size={8}>
        <Controller
          name="quote.supplierReference"
          defaultValue=""
          render={({ field, fieldState: { error } }) => (
            <TextField
              disabled={!edit[DetailsFormField.SUPPLIER_REFERENCE]}
              label={t('supplierReference')}
              error={!!error}
              helperText={errorToHelperText(error)}
              {...commonInputProps}
              {...field}
              value={field.value ?? ''}
              slotProps={{
                inputLabel: { shrink: true },
              }}
            />
          )}
        />
      </Grid>
    </>
  );
};
